module.exports = __webpack_public_path__ + "static/media/plus_yellow.7b21eb4f.svg";